import AbstractEntity, {AbstractEntityFields} from "~/ts/library/AbstractEntity";
import {PlatformInterface} from "~/cabinet/ts/data/integrations/Platform";
import Auth from "~/cabinet/ts/data/integrations/Auth";

export default class AuthListByPlatformTypeResponse extends AbstractEntity {
    platforms!: PlatformInterface[];
    authList!: Auth[];

    protected getFields(): AbstractEntityFields {
        return {
            authList: Auth
        }
    }
}